import type { IntlShape } from 'react-intl-next';
import type { EditorState } from 'prosemirror-state';

import type { ExtractInjectionAPI, FloatingToolbarConfig } from '@atlaskit/editor-common/types';
import type { ProviderFactory } from '@atlaskit/editor-common/provider-factory';

import type { ExtensionManagerPlugin } from '../createPlugin';

import { anchorMacroToolbarOverride } from './anchor/anchorMacroToolbarOverride';

export const getToolbarConfig = (
	state: EditorState,
	intl: IntlShape,
	_providerFactory: ProviderFactory,
	activeConfigs?: Array<FloatingToolbarConfig>,
	api?: ExtractInjectionAPI<ExtensionManagerPlugin>,
): FloatingToolbarConfig | undefined => {
	if (!activeConfigs?.length) return;

	const overrides = [anchorMacroToolbarOverride];

	activeConfigs.forEach((config: FloatingToolbarConfig) => {
		overrides.forEach(({ shouldApplyOverride, applyOverride }) => {
			if (shouldApplyOverride(state, config)) {
				applyOverride(config, intl, api);
			}
		});
	});
};
